import React from 'react';
import { Link } from 'react-router-dom';

import { TableActions } from 'components/Table/TableActions';
import i18n from 'translations';
import { IDealerTicket } from 'thunks/RTKQuery/dealer';

export interface IActionsProps {
  ticket: IDealerTicket;
  showActions: boolean;
  onDelete: (ticket: IDealerTicket) => void;
}

export const Actions = ({ ticket, showActions, onDelete }: IActionsProps) => {
  return (
    <div className="visible-actions">
      <TableActions>
        {showActions && (
          <>
            <Link
              to={`/dealer/license/info?licenseKey=${ticket.ticketId}`}
              onClick={(e) => {
                e.preventDefault();
                window.open(
                  `/dealer/license/info?licenseKey=${ticket.ticketId}`,
                  '_blank'
                );
              }}
            >
              {i18n.t('account.company.information')}
            </Link>
            <Link
              data-cy="delete-user-action"
              to="#"
              onClick={() => onDelete(ticket)}
            >
              {ticket.isArchived
                ? i18n.t('customerManagement.actions.unarchive')
                : i18n.t('customerManagement.actions.archive')}
            </Link>
          </>
        )}
      </TableActions>
    </div>
  );
};
